// shared/services/alert.service.ts

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AlertMessage, AlertType } from '../models/Alert.model';

@Injectable({
    providedIn: 'root'
})
export class AlertService {

    private alertSubject = new BehaviorSubject<AlertMessage>({
        type: 'info',
        message: '',
        visible: false
    });

    alert$ = this.alertSubject.asObservable();

    show(type: AlertType, message: string, duration = 4000): void {
        debugger
        this.alertSubject.next({
            type,
            message,
            visible: true
        });

        setTimeout(() => {
            this.hide();
        }, duration);
    }

    success(message: string): void {
        debugger
        this.show('success', message);
    }

    error(message: string): void {
        debugger
        this.show('danger', message);
    }

    warning(message: string): void {
        this.show('warning', message);
    }

    info(message: string): void {
        this.show('info', message);
    }

    hide(): void {
        debugger
        this.alertSubject.next({
            type: 'info',
            message: '',
            visible: false
        });
    }
}